import { render, staticRenderFns } from "./SeoText.vue?vue&type=template&id=4c1157e6&lang=pug"
import script from "./SeoText.vue?vue&type=script&lang=js"
export * from "./SeoText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports